import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import PageHeader from '../common/PageHeader/PageHeader';
import { Button } from '@praktio/common-ui';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';

import { getCourses } from '../../ducks/courses';
import { RootState } from '../../ducks/store';
import Table from '../common/Table/Table';

import './Courses.scss';

const CourseColumns = [
  { Header: 'Title', accessor: 'title' },
  {
    Header: 'Published',
    accessor: 'published',
    Cell: (props: any) => {
      const published = props.row.original.published;
      return (
        <i
          className={classNames('material-icons', {
            green: published,
            red: !published,
          })}
        >
          {published ? 'check_circle' : 'cancel'}
        </i>
      );
    },
  },
  { Header: 'Expiration Span (Days)', accessor: 'expirationSpan' },
  {
    Header: 'In Order Module Completion',
    accessor: 'modulesInOrder',
    Cell: (props: any) => {
      const modulesInOrder = props.row.original.modulesInOrder;
      return (
        <i
          className={classNames('material-icons', {
            green: modulesInOrder,
            red: !modulesInOrder,
          })}
        >
          {modulesInOrder ? 'check_circle' : 'cancel'}
        </i>
      );
    },
  },
  {
    Header: 'Certificate Upon Completion',
    accessor: 'certUponComplete',
    Cell: (props: any) => {
      const certUponComplete = props.row.original.certUponComplete;
      return (
        <i
          className={classNames('material-icons', {
            green: certUponComplete,
            red: !certUponComplete,
          })}
        >
          {certUponComplete ? 'check_circle' : 'cancel'}
        </i>
      );
    },
  },
];

const Courses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { courses } = useSelector((state: RootState) => {
    return {
      courses: state.courses.list,
    };
  });

  useEffect(() => {
    dispatch(getCourses());
  }, [dispatch]);

  return (
    <Container fluid className="Courses">
      <Helmet>
        <title>Courses - Praktio</title>
      </Helmet>
      <Row className="h-100">
        <Col className={classNames('p-0 h-100 d-flex flex-column col-xs-12')}>
          <PageHeader pageName="Courses">
            <Button onClick={() => navigate(`/admin/courses/new`)}>Add</Button>
          </PageHeader>
          <div className="Courses-content">
            <Table
              columns={CourseColumns}
              data={courses}
              onRowClick={(row) => navigate(`/admin/courses/${row.original._id}`)}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Courses;
